const sliderMain = document.querySelector('.slider-main');

const defaultSliderOptions = {
  watchOverflow: true,
  observer: true,
  resizeObserver: true,
  speed: 2200,
  navigation: {
    nextEl: '.slider__main-next',
    prevEl: '.slider__main-prev',
    enabled: false
  }
};

const initSlider = (elem) => {
  if (!elem) return;

  const countsElements = elem.querySelectorAll('.slider__main-item').length;
  const sliderOptions = {...defaultSliderOptions};

  if (countsElements > 1) {
    sliderOptions.effect = "fade";
    sliderOptions.fadeEffect = {
      crossFade: true
    };
    sliderOptions.loop = true;
    sliderOptions.navigation.enabled = true;
  }

  if (elem.hasAttribute('data-autoplay')) {
    sliderOptions.autoplay = {
      delay: 2200,
      disableOnInteraction: false
    };
  }

  const swiper = new Swiper(elem, sliderOptions);
}

if (sliderMain) {
    initSlider(sliderMain);
}
